import styled from 'styled-components';
import { buttonSize } from '../PaginatorContainer/styles';
import { flexCenter } from '@/styles/layout';
import { bodySmall } from '@/styles/typography';
import { COLORS } from '@/styles/colors';

export const PaginatorDots = styled.span`
  ${buttonSize};
  ${flexCenter};
  ${bodySmall};
  color: ${COLORS.grey[700]};
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;

  &:hover {
    background: ${COLORS.grey[200]};
  }
`;

export const JumpForm = styled.form`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  min-width: 0;

  input {
    width: 72px;
  }
`;
